import { getCampaignEditorUrl } from 'utils/appRoutes';
import { CampaignState } from 'modules/domains/campaign';
import { useGetCampaignResourceData } from '../hooks/useGetCampaignResourceData';
import { useGetTemplateThumbnailData } from '../hooks/useGetTemplateThumbnailData';
import { ActivityItem as ActivityItemType } from '../Launchpad.types';
import { ActivityItem } from './ActivityItem';

export const CampaignItem = (props: {
  item: ActivityItemType;
  titleWidth: number;
}) => {
  // Resource data
  const { resource, isLoading, hasError } = useGetCampaignResourceData(props.item.resourceId);
  const { templateId, messageMedium } = resource || {};

  // Resource url
  const url = getCampaignEditorUrl(resource);

  // Resource thumbnail
  const { thumbnail, isThumbnailLoading } = useGetTemplateThumbnailData({
    templateId,
    messageMedium,
  });

  return (
    <ActivityItem
      {...props}
      isHidden={resource.campaignState === CampaignState.Archived}
      isLoading={isLoading}
      hasError={hasError}
      resource={resource}
      thumbnail={thumbnail}
      isThumbnailLoading={isThumbnailLoading}
      url={url}
    />
  );
};
